export default __webpack_public_path__ + "static/media/guia-2-3.b3a5b189.svg";